import React from 'react'
import { ListGroup, ListGroupItem } from 'react-bootstrap'
import { withRouter } from 'react-router-dom'
import styledComponents from 'styled-components'
import _ from 'lodash'

class DebtorSideMenu extends React.Component {
  goTo = _.memoize((url) => () => {
    this.props.history.push(url)
  })

  menus = [
    { title: 'Agent', to: '/debtor/agent' },
    { title: 'Airline', to: '/debtor/airline' },
    { title: 'Card', to: '/debtor/card' },
  ]

  isActive = (url) => this.props.location.pathname === url

  render() {
    return (
      <SideMenuLayout>
        <ListGroup>
          {this.menus &&
            this.menus.map((menu, i) => (
              <ListGroupItem
                key={menu.to}
                active={this.isActive(menu.to)}
                disabled={menu.disabled}
                onClick={this.goTo(menu.to)}
              >
                <strong>{menu.title}</strong>
              </ListGroupItem>
            ))}
        </ListGroup>
      </SideMenuLayout>
    )
  }
}

export default withRouter(DebtorSideMenu)

const SideMenuLayout = styledComponents.div`
  flex: 1;
  min-width: 200px;
  margin-right: 16px;
`
